<ng-container *transloco="let _t">

<div class="row" *ngIf="incident">
	<div class="col-3">
		<!-- nature -->
		<div class="mat-form-field">
			<label>{{ _t('incident-form-label-0') }}</label>
			<input matInput type="text" [(ngModel)]="incident.nature" 
			[ngClass]="{'error': showErrors && incident.nature==''}"/>
		</div>

		<!-- date heure -->
		<div class="row" style="margin:0">
			<div class="col-7 datetime">
				<label>{{ _t('incident-form-label-1') }}</label>
				<input matInput type="date" [(ngModel)]="incident.date"  
				[ngClass]="{'error': showErrors && incident.date==''}" />
				<!--
				<input matInput [matDatepicker]="picker"
					(click)="picker.open()" (focus)="picker.open()"
					[(ngModel)]="incident.date"  
					[ngClass]="{'error': showErrors && incident.date==''}">
				<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
				<mat-datepicker #picker></mat-datepicker>
				-->
			</div>

			<div class="col-5 datetime">
				<label>{{ _t('incident-form-label-2') }}</label>
				<input matInput type="time"
					[(ngModel)]="incident.heure" 
					[ngClass]="{'error': showErrors && incident.heure==''}" />
			</div>
		</div>

		<div class="mat-form-field">
			<label>{{ _t('incident-form-label-4') }}</label><br>
			<mat-radio-group
				[(ngModel)]="gravity" >
				<mat-radio-button [value]="1" class="mat-basic">
					{{ _t('incident-form-radio-1') }}
				</mat-radio-button>

				<mat-radio-button [value]="2" class="mat-danger">
					{{ _t('incident-form-radio-2') }}
				</mat-radio-button>
				
				<mat-radio-button [value]="3" class="mat-warn">
					{{ _t('incident-form-radio-3') }}
				</mat-radio-button>
			</mat-radio-group>
		</div>
		
	</div>

	<div class="col-5">
<!--
		<div class="col-12 forinput">
			<label>{{ _t('incident-form-label-5') }}</label>
			<input matInput type="text" [(ngModel)]="incident.cout"  />
		</div>
-->



		<div class="col-12 fortextarea description mat-form-field">
			<label>{{ _t('incident-form-label-3') }}</label>
			<textarea matInput type="text" [(ngModel)]="incident.description">
			</textarea>
		</div>
		

		<div class="fortextarea measures mat-form-field">
			<label>{{ _t('incident-form-label-6') }}</label>
			<textarea matInput type="text" [(ngModel)]="incident.measures" >
			</textarea>
		</div>

		
	</div>

	<div class="col-4">
		<cmat-picture
			class="editor-mainphoto"
			[src]="incident.photo" 
			[alt]="_t('incident-form-photo')" 
			[uploadable]="true" 
			(changeTriggered)="incident.photo=$event"
		></cmat-picture>
	</div>

</div>

</ng-container>